import React from 'react'
import { useModal } from '../hooks/useModal'

// Series-scope delete modal — adversarial-review fix (MEDIUM UX).  Wraps
// the picker in useModal so keyboard users get Esc-to-close + Tab focus trap
// + auto-focus first button + body scroll lock + return-focus-on-close +
// aria-modal semantics.  Backdrop click also dismisses (matches useAsk
// behavior for confirmation dialogs).
//
// Extracted from Calendar.js for feedback #822 so the Tasks page can offer
// the same scope picker.  Deleting a series SEED without going through this
// picker is genuinely dangerous: events.series_id is ON DELETE CASCADE, so a
// naive delete of the seed wipes every child.  The backend guards that with
// seed-promotion (calendar.js), but the user still has to be asked which
// scope they meant — hence one shared modal rather than two copies that can
// drift.
export default function SeriesDeleteModal({ prompt, onClose, onConfirm }) {
  const { containerProps } = useModal({ onClose, enabled: true })
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
         onClick={onClose}>
      <div {...containerProps}
           className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6"
           onClick={e => e.stopPropagation()}
           aria-labelledby="series-del-title">
        <h3 id="series-del-title" className="text-lg font-semibold text-gray-800 mb-2">Delete recurring event</h3>
        <p className="text-sm text-gray-600 mb-5">
          This event is part of a recurring series. What would you like to delete?
          <br />
          <span className="text-xs text-gray-500 italic">"{prompt.title}"</span>
        </p>
        <div className="space-y-2">
          <button onClick={() => onConfirm('this')}
            className="w-full text-left px-4 py-3 rounded-lg border border-gray-200 hover:bg-gray-50 hover:border-primary-300 transition-colors">
            <div className="font-medium text-gray-800">This event only</div>
            <div className="text-xs text-gray-500 mt-0.5">Removes only this occurrence. Other members of the series stay.</div>
          </button>
          <button onClick={() => onConfirm('future')}
            className="w-full text-left px-4 py-3 rounded-lg border border-gray-200 hover:bg-gray-50 hover:border-primary-300 transition-colors">
            <div className="font-medium text-gray-800">This event and all following</div>
            <div className="text-xs text-gray-500 mt-0.5">Removes this and every future occurrence in the series. Past occurrences stay.</div>
          </button>
          <button onClick={() => onConfirm('series')}
            className="w-full text-left px-4 py-3 rounded-lg border border-red-200 hover:bg-red-50 hover:border-red-300 transition-colors">
            <div className="font-medium text-red-700">Delete the entire series</div>
            <div className="text-xs text-gray-500 mt-0.5">Removes every occurrence, past and future.</div>
          </button>
        </div>
        <div className="flex justify-end mt-5">
          <button onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800">
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
